import { combineReducers } from "redux";
import constants from "./constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  getLeadTargetResult: createApiReducer(constants.GET_LEAD_TARGET, {}),
  saveCRMSettingLeadFormResult: createApiReducer(constants.SAVE_CRM_SETTING_LEAD_FORM, {}),
  setGateItemResult: createApiReducer(constants.SET_GATE_ITEM, { gateItem: {} }),
  saveCRMGGLeadsSettingResult: createApiReducer(constants.SAVE_CRM_GG_LEADS_SETTING, {}),
  setCRMLoadingResult: createApiReducer(constants.SET_CRM_LOADING, {}),
  setValidateGateResult: createApiReducer(constants.SET_VALIDATE_GATE, { validateGate: {} }),
});

export default reducers;
